import { useEffect, useState } from "react";
import { AI_SERVER_PATH } from "../utils/utils";

const useVocabulary = () => {
  const [vocabularies, setVocabularies] = useState([]);
  const [vocabulary, setVocabulary] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);

  const VOCABULARY_PATH = AI_SERVER_PATH + "/vocabulary";

  useEffect(() => {
    fetch(VOCABULARY_PATH)
      .then((response) => response.json())
      .then((data) => {
        const formattedData = data.map((row, index) => ({
          index: index + 1,
          english: row.english,
          vietnamese: row.vietnamese,
        }));
        setVocabularies(formattedData);
      })
      .catch((error) => console.error("Error fetching vocabulary:", error));
  }, []); // Empty dependency array to ensure this runs once on mount

  useEffect(() => {
    console.log(vocabularies[currentIndex]);
    setVocabulary(vocabularies[currentIndex]);
  }, [vocabularies, currentIndex]);

  const nextWord = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % vocabularies.length);
  };

  const prevWord = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + vocabularies.length) % vocabularies.length
    );
  };

  const updateVocabulary = (newEnglish) => {
    setVocabularies((prevVocabulary) => {
      const updatedVocabulary = [...prevVocabulary];
      updatedVocabulary[currentIndex] = {
        ...updatedVocabulary[currentIndex],
        english: newEnglish,
      };
      return updatedVocabulary;
    });
  };

  return {
    vocabularies,
    currentIndex,
    nextWord,
    prevWord,
    updateVocabulary,
    vocabulary,
  };
};

export default useVocabulary;
